import { linkShortcutsBlueprint } from "@made-people/blueprint-link-shortcuts/blueprint";

linkShortcutsBlueprint.override({
  slots: {
    base: "flex gap-x-component-x-spacing-xs lg:gap-x-component-x-spacing-md",
    heading: "px-component-x-spacing-xs lg:px-0",
    linksWrapper:
      "flex justify-start gap-2 overflow-x-auto overflow-y-visible py-1",
  },
  variants: {
    layout: {
      column: {
        base: "flex flex-col",
        heading: "w-full text-center",
        linksWrapper: "w-full flex flex-row justify-around items-center",
      },
      grid: {
        base: "flex flex-col",
        heading: "w-full text-center",
        linksWrapper: "grid grid-cols-2 md:grid-cols-6 w-full",
        link: "col-span-1 flex justify-center items-center",
      },
    },
  },
  // defaultVariants: {
  //   layout: {
  //     // initial: "grid",
  //   },
  // },
});
